import React, { useContext } from 'react';
import { ThemeContext } from '../theme';

/**
 * Reusable button matching the Taleo auth-screen design system.
 *
 * Props:
 *   variant  — 'primary' | 'secondary' | 'tertiary' (default 'primary')
 *   onClick
 *   children
 *   scale    — uniform size multiplier (default 1)
 *   style    — optional extra styles (e.g. flex: 1)
 */
export default function Button({ variant = 'primary', onClick, children, scale = 1, style }) {
  const theme = useContext(ThemeContext);
  const s = (n) => Math.round(n * scale);

  const isTertiary  = variant === 'tertiary';
  const isSecondary = variant === 'secondary';

  const bgMap = {
    primary:   theme.btnPrimaryBg,
    secondary: theme.btnSecondaryBg,
    tertiary:  theme.btnTertiaryBg,
  };
  const fgMap = {
    primary:   theme.btnPrimaryText,
    secondary: theme.btnSecondaryText,
    tertiary:  theme.btnTertiaryText,
  };

  const base = {
    padding: `${s(20)}px`,
    borderRadius: s(20),
    border: isSecondary ? `1px solid ${theme.btnSecondaryBorder}` : 'none',
    fontSize: s(18),
    lineHeight: `${s(24)}px`,
    fontWeight: 700,
    cursor: 'pointer',
    backgroundColor: bgMap[variant] ?? bgMap.primary,
    color: fgMap[variant] ?? fgMap.primary,
    ...style,
  };

  return (
    <button
      onClick={onClick}
      className="font-satoshi font-bold"
      style={base}
    >
      {children}
    </button>
  );
}
